import {
  APP_COMPONENT_STATUSES,
  APP_STATUS_IMPACT,
  AppIncident,
  BackResponse,
  BackResponseFailure,
  INCIDENT_STATUSES,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';

import { adaptRawAppIncidentToAppIncident } from './adapters';
import STATUS_PAGE_URL from './config';

export interface RawUnresolvedIncidentsResponse {
  page: {
    id: string;
    name: string;
    url: string;
    updated_at: string;
  };
  incidents: {
    components: {
      created_at: string;
      description: string | null;
      group: boolean;
      group_id: string | null;
      id: string;
      name: string;
      only_show_if_degraded: boolean;
      page_id: string;
      position: number;
      showcase: boolean;
      start_date: string;
      status: APP_COMPONENT_STATUSES;
      updated_at: string;
    }[];
    created_at: string;
    id: string;
    impact: APP_STATUS_IMPACT;
    incident_updates: {
      body: string;
      created_at: string;
      display_at: string;
      id: string;
      incident_id: string;
      status: INCIDENT_STATUSES;
      updated_at: string;
    }[];
    monitoring_at: null;
    name: string;
    page_id: string;
    resolved_at: null;
    shortlink: string;
    status: INCIDENT_STATUSES;
    updated_at: string;
  }[];
}

const getAppIncidents = async (): Promise<
  BackResponse<AppIncident[]> | BackResponseFailure
> => {
  const ENDPOINT = `${STATUS_PAGE_URL}/api/v2/incidents.json`;

  try {
    const response = await fetch(ENDPOINT);

    const rawUnresolvedIncidentsResponse =
      (await response.json()) as RawUnresolvedIncidentsResponse;

    const returnValue: BackResponse<AppIncident[]> = {
      failure: false,
      isHandledError: false,
      hasWarnings: false,
      isNotFound: false,
      errors: [],
      value: adaptRawAppIncidentToAppIncident(rawUnresolvedIncidentsResponse),
    };

    return returnValue;
  } catch (e) {
    return prepareResponseFailure(e);
  }
};

export default getAppIncidents;
